import {
  ApiAssetPriceWithOverride,
  ApiMutualFundAsset,
  ApiPerformance,
  ApiSegregatedPortfolioAsset
} from '../../../api/_legacy/generated-api'
import { Statistic } from '../detailed-tabs/statistics'

export function mapAssetToMutualFund(asset: any): ApiMutualFundAsset {
  const mutualFund = {
    type: asset.type,
    fundManager: asset.fundManager,
    externalIdentifiers: {
      managementCompanyCode: asset.externalIdentifiers.managementCompanyCode,
      fundCode: asset.externalIdentifiers.fundCode,
      productCode: asset.externalIdentifiers.productCode,
      accountNumber: asset.externalIdentifiers.accountNumber,
      fundManagerCounterpartyId: asset.externalIdentifiers.fundManagerCounterpartyId
    },
    assetId: asset.assetId,
    isinCode: asset.isinCode,
    clientAssetId: asset.clientAssetId,
    name: asset.name,
    assetClass: asset.assetClass,
    marketDataProvider: 'FinSwitch',
    tradingProvider: 'FinSwitch',
    currencyIso: asset.currencyIso,
    sharePrecisionScale: asset.sharePrecisionScale,
    priceScalingFactor: asset.priceScalingFactor,
    dealingFrequency: asset.dealingFrequency,
    dealingState: asset.dealingState,
    protectionClassification: asset.protectionClassification,
    dealingCalendar: asset.dealingCalendar,
    noticePeriodDays: asset.noticePeriodDays,
    cutoffTimeHours: asset.cutoffTimeHours,
    cutoffTimeMinutes: asset.cutoffTimeMinutes,
    targetVolatility: asset.targetVolatility,
    multiplier: asset.protectionClassification === 'Performance' ? asset.multiplier : null,
    maxLeverageRatio: asset.maxLeverageRatio,
    taxClassification:
      asset.protectionClassification === 'Protection' ? 'Yield' : asset.taxClassification,
    fees: asset.fees,
    disallowedStrategies: asset.disallowedStrategies,
    assetTradeStatus: asset.assetTradeStatus,
    assetRebalancingStatus: asset.assetRebalancingStatus,
    isMarketDataReady: asset.isMarketDataReady
  }
  return mutualFund as ApiMutualFundAsset
}

export function mapAssetToSegPortfolio(asset: any): ApiSegregatedPortfolioAsset {
  const segPortfolio = {
    type: asset.type,
    assetId: asset.assetId,
    isinCode: asset.isinCode,
    clientAssetId: asset.clientAssetId,
    clientId: '',
    name: asset.name,
    assetClass: asset.assetClass,
    marketDataProvider: 'Absa',
    tradingProvider: 'Absa',
    currencyIso: asset.currencyIso,
    sharePrecisionScale: asset.sharePrecisionScale,
    priceScalingFactor: asset.priceScalingFactor,
    dealingFrequency: asset.dealingFrequency,
    dealingState: asset.dealingState,
    protectionClassification: asset.protectionClassification,
    dealingCalendar: asset.dealingCalendar,
    noticePeriodDays: asset.noticePeriodDays,
    cutoffTimeHours: asset.cutoffTimeHours,
    cutoffTimeMinutes: asset.cutoffTimeMinutes,
    targetVolatility: asset.targetVolatility,
    multiplier: asset.protectionClassification === 'Performance' ? asset.multiplier : null,
    maxLeverageRatio: asset.maxLeverageRatio,
    taxClassification:
      asset.protectionClassification === 'Protection' ? 'Yield' : asset.taxClassification,
    fees: asset.fees,
    disallowedStrategies: asset.disallowedStrategies,
    assetTradeStatus: asset.assetTradeStatus,
    assetRebalancingStatus: asset.assetRebalancingStatus,
    startDate: asset.startDate,
    isMarketDataReady: asset.isMarketDataReady
  }
  return segPortfolio as ApiSegregatedPortfolioAsset
}

export function mapAssetPricesToTimeseries(
  prices: ApiAssetPriceWithOverride[]
): Record<string, number> {
  const ts = {}
  prices.forEach(x => (ts[x.valueDate] = x.price))
  return ts
}

export function mapPerfMetricsToStatistics(
  metrics: ApiPerformance[],
  period: string[]
): Statistic[] {
  const stats = []
  metrics.forEach(x =>
    stats.push({
      period: period[metrics.indexOf(x)],
      return: Object.keys(x).length === 0 ? null : x.totalReturn,
      volatility: Object.keys(x).length === 0 ? null : x.annualisedVolatility,
      maxDrawdown: Object.keys(x).length === 0 ? null : x.maxDrawdown,
      sharpe: Object.keys(x).length === 0 ? null : x.sharpeRatio
    })
  )
  return stats
}
